<template>
  <div class="trial-plan">
    <!--Title-->
    <div class="info-wrapper">
      <div class="title-wrapper">
        <h3>
          {{ content.title }}
        </h3>
        <span class="table-tag" :class="trialDaysLeft > 0 ? 'green' : 'red'">{{
          trialDaysLeft > 0 ? "Active" : "Expired"
        }}</span>
      </div>
      <p>{{ content.description }}</p>
    </div>

    <!--Usage-->
    <div class="usage-wrapper">
      <div class="usage-details">
        <div class="term-details">
          <span>{{ trialStartDate.format("D MMM YYYY") }}</span>
          to
          <span>{{ trialEndDate.format("D MMM YYYY") }}</span>
        </div>
        <div v-if="trialDaysLeft >= 0" class="answers-count">
          <span>{{ trialDaysLeft }}</span> of
          {{ trial.trialDays }}
          {{ trial.trialDays === 1 ? "day" : "days" }} remaining
        </div>
        <div v-else class="answers-count">Trial expired</div>
      </div>
      <div class="usage-bar">
        <span
          class="current-usage"
          :style="trialProgressWidth"
          :class="usageClass"
        ></span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "TrialDays",
  props: {
    content: Object,
    trial: Object,
  },
  data() {
    return {};
  },
  computed: {
    // Trial starting date
    trialStartDate() {
      return this.moment(this.trial.startDate);
    },

    // Trial starting date
    trialEndDate() {
      return this.moment(this.trial.startDate).add(
        "days",
        this.trial.trialDays
      );
    },

    // Remaining trial days
    trialDaysLeft() {
      return this.trialEndDate.diff(this.moment(), "days");
    },

    // Send the current usage style
    trialProgressWidth() {
      return `width: ${
        ((this.trial.trialDays - this.trialDaysLeft) / this.trial.trialDays) *
        100
      }%`;
    },

    // Determine the class based on the usage
    usageClass() {
      const currentUsage =
        ((this.trial.trialDays - this.trialDaysLeft) / this.trial.trialDays) *
        100;

      if (currentUsage >= 100) return "exceeded";
      else if (currentUsage < 50) return "low";
      else if (currentUsage > 50 && currentUsage < 85) return "medium";
      else if (currentUsage > 85) return "low";

      return "low";
    },
  },
  created() {},
  methods: {},
};
</script>

<style scoped lang="scss">
@import "@/assets/styles/shared/dashboard.scss";

.info-wrapper {
  .title-wrapper {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 0.5rem;
    margin-bottom: 0.25rem;

    h3 {
      font-family: $titleFont;
      font-size: $mediumFontSize;
      margin-bottom: 0;
    }
  }

  p {
    font-size: $smallFontSize;
    opacity: $lightOpacity;
  }
}

.trial-plan {
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  justify-content: space-between;

  .usage-wrapper {
    flex: 1;
    max-width: 35rem;

    .usage-details {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
      font-size: $smallerFontSize;
      color: lighten($greyColor, 10%);
      margin-bottom: 0.5rem;

      .answers-count {
        text-align: right;
      }

      span {
        color: $greyColor;
        font-weight: $boldFontWeight;
        font-size: $normalFontSize;
      }

      .term-details {
        span {
          font-size: $smallFontSize;
          font-weight: 600;
        }
      }
    }

    .usage-bar {
      position: relative;
      overflow: hidden;
      background: darken($whiteColor, 7.5%);
      height: 0.5rem;
      width: 100%;
      border-radius: 0.5rem;

      .current-usage {
        position: absolute;
        top: 0;
        left: 0;
        height: 100%;

        &.low {
          background-color: $greenColor;
        }

        &.medium {
          background-color: $purpleColor;
        }

        &.high {
          background-color: $orangeColor;
        }

        &.exceeded {
          background-color: $redColor;
        }
      }
    }
  }
}
</style>
